// Spracheingabe pro Feld (US-3.6): MediaRecorder → Upload an UNSEREN Server →
// serverseitige Transkription (Mistral/Voxtral) → Transkript editierbar ins
// Feld. Die Web Speech API ist verboten (Chrome würde Audio an Google
// schicken); der Browser spricht ausschließlich mit unserem Server.
//
// Zustände immer sichtbar (CD): Aufnahme läuft (pulsierender Korall-Punkt),
// Umwandlung läuft, übernommen. Die Datenverarbeitung ist zu Beginn des
// Fragebogens erklärt; Tippen bleibt immer der Ausweichweg.

let activeRecorder = null

function statusElement(wrapper) {
  return wrapper.querySelector('.audio-status')
}

function setStatus(wrapper, text) {
  statusElement(wrapper).textContent = text
}

function setButtonState(button, state, label) {
  button.classList.remove('-recording', '-transcribing')
  if (state) button.classList.add(state)
  button.querySelector('.audio-label').textContent = label
}

function insertTranscript(wrapper, transcript) {
  const field = document.getElementById(wrapper.dataset.target)
  if (!field) return

  const existing = field.value.trim()
  field.value = existing ? `${existing}\n${transcript}` : transcript
  field.dispatchEvent(new Event('input', { bubbles: true }))
  field.focus()
}

async function uploadRecording(wrapper, button, blob) {
  setButtonState(button, '-transcribing', 'Wird umgewandelt …')
  setStatus(wrapper, '')

  const formData = new FormData()
  formData.append('audio', blob, 'aufnahme.webm')

  try {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    const response = await fetch(wrapper.dataset.transcribeUrl, {
      method: 'POST',
      headers: csrfToken ? { 'X-CSRF-Token': csrfToken } : {},
      body: formData,
    })
    const data = await response.json()

    if (response.ok && data.transcript) {
      insertTranscript(wrapper, data.transcript)
      setStatus(wrapper, 'Übernommen, Sie können den Text noch anpassen.')
    } else {
      setStatus(wrapper, data.error || 'Spracheingabe gerade nicht verfügbar, Sie können den Text auch tippen.')
    }
  } catch {
    setStatus(wrapper, 'Spracheingabe gerade nicht verfügbar, Sie können den Text auch tippen.')
  } finally {
    setButtonState(button, null, 'Antwort einsprechen')
  }
}

async function startRecording(wrapper, button) {
  // CR-7: Es läuft immer nur eine Aufnahme. Eine noch laufende Aufnahme an
  // einem anderen Feld wird gestoppt (und damit hochgeladen), bevor die
  // neue beginnt.
  if (activeRecorder && activeRecorder.state === 'recording') {
    activeRecorder.stop()
  }

  let stream
  try {
    stream = await navigator.mediaDevices.getUserMedia({ audio: true })
  } catch {
    setStatus(wrapper, 'Das Mikrofon ist nicht freigegeben, Sie können den Text auch tippen.')
    return
  }

  let recorder
  try {
    recorder = new MediaRecorder(stream)
  } catch {
    stream.getTracks().forEach((track) => track.stop())
    setStatus(wrapper, 'Aufnahme wird von diesem Browser nicht unterstützt, Sie können den Text auch tippen.')
    return
  }
  const chunks = []
  recorder.addEventListener('dataavailable', (event) => chunks.push(event.data))
  recorder.addEventListener('stop', () => {
    stream.getTracks().forEach((track) => track.stop())
    // Nur den eigenen Eintrag löschen: eine inzwischen gestartete Aufnahme
    // an einem anderen Feld darf nicht ihren Knopf verlieren.
    if (activeRecorder === recorder) activeRecorder = null
    uploadRecording(wrapper, button, new Blob(chunks, { type: recorder.mimeType || 'audio/webm' }))
  })

  activeRecorder = recorder
  recorder.start()
  setButtonState(button, '-recording', 'Aufnahme läuft, zum Stoppen klicken')
  setStatus(wrapper, '')
}

function toggleRecording(wrapper, button) {
  if (button.classList.contains('-recording')) {
    activeRecorder?.stop()
  } else if (button.classList.contains('-transcribing')) {
    // Während der Umwandlung ist der Knopf passiv.
  } else {
    startRecording(wrapper, button)
  }
}

// Event-Delegation statt up.compiler (siehe CLAUDE.md: Compiler sind hier
// unzuverlässig), funktioniert auch für von Unpoly eingesetzte Fragmente.
document.addEventListener('click', (event) => {
  const wrapper = event.target.closest('.audio-input')
  if (!wrapper) return

  if (event.target.closest('.audio-record-btn')) {
    event.preventDefault()
    toggleRecording(wrapper, wrapper.querySelector('.audio-record-btn'))
  }
})
